import { Badge, Text, Tooltip, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface BrandCellProps {
  brand: { id: number; name: string } | null;
  brandConfidence: number;
}

export const BrandCell: React.FC<BrandCellProps> = ({ brand, brandConfidence }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', padding: '8px 0', maxWidth: '100%' }}>
    <VStack align='start' spacing={1} maxW='100%'>
      {brand ? (
        <>
          <Tooltip label={brand?.name} isDisabled={brand?.name?.length <= 25}>
            <Text
              fontWeight='medium'
              fontSize='md'
              color='blue.600'
              lineHeight='1.2'
              maxW='100%'
              wordBreak='break-word'
              whiteSpace='normal'
              noOfLines={2}>
              {brand?.name}
            </Text>
          </Tooltip>
          <Badge colorScheme='blue' variant='subtle' size='sm'>
            Confidence: {Math.round(brandConfidence * 100)}%
          </Badge>
        </>
      ) : (
        <Text fontSize='sm' color='gray.500' fontStyle='italic'>
          Master brand not mapped
        </Text>
      )}
    </VStack>
  </div>
);
